import UserRegistrationComponent from "../../components/UserRegistrationComponent";

export default UserRegistrationComponent;
